import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

const getFunction = async (url, type, errorType, dispatch) => {
  try {
    const getRequestSuccess = await axios.get(url);
    const { data } = getRequestSuccess;
    dispatch({
      type: type,
      payload: data
    });
  } catch (getRequestError) {
    const errorData = {
      data: getRequestError.response.data,
      status: getRequestError.response.status
    };
    dispatch({
      type: errorType,
      payload: errorData
    });
  }
};

// set loading
const setDprLoading = (data) => (dispatch) => {
  dispatch({
    type: types.DprFormTypes.DPR_SET_CREATE_LOADING,
    payload: data
  });
};

// clear result
const clearDprResult = () => (dispatch) => {
  dispatch({
    type: types.DprFormTypes.DPR_CLEAR_RESULT
  });
};

// clear error
const clearDprErrors = () => (dispatch) => {
  dispatch({
    type: types.DprFormTypes.DPR_CLEAR_ERRORS
  });
};

const addAndEditDpr = (dprData, dprId, loginType) => async (
  dispatch
) => {
  try {
    console.log(dprData, dprId, loginType);
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const url = `${baseUrlNode}${api.Dpr_Api.ADD_EDIT_DPR_API}/${dprId}/${loginType}`;
    const addDprSuccess = await axios.post(url, dprData);
    dispatch({
      type: types.DprFormTypes.ADD_DPR,
      payload: addDprSuccess.data
    });
  } catch (dprError) {
    const errorData = {
      data: dprError.response.data,
      status: dprError.response.status
    };
    dispatch({
      type: types.DprFormTypes.DPR_ERRORS,
      payload: errorData
    });
  }
};

const getAllDpr = (dprDate, locationId, loginType) => async (
  dispatch
) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Dpr_Api.GET_ALL_DPR_API}/${dprDate}/${locationId}/${loginType}`;
  const type = types.DprFormTypes.GET_ALL_DPR;
  const errorType = types.DprFormTypes.DPR_ERRORS;
  dispatch({
    type: types.DprFormTypes.ALL_DPR_INPUTS,
    payload: {
      dprDate: dprDate,
      dprLocation: locationId
    }
  });
  getFunction(url, type, errorType, dispatch);
};

const getDprDetails = (dprId, loginType) => async (dispatch) => {
  const { baseUrlNode } = await helperFunction.checkLoginType(
    loginType
  );
  const url = `${baseUrlNode}${api.Dpr_Api.GET_DPR_DETAILS_API}/${dprId}/${loginType}`;
  const type = types.DprFormTypes.GET_DPR_DETAILS;
  const errorType = types.DprFormTypes.DPR_ERRORS;
  getFunction(url, type, errorType, dispatch);
};

export {
  setDprLoading,
  clearDprResult,
  clearDprErrors,
  addAndEditDpr,
  getAllDpr,
  getDprDetails
};
